import { render, staticRenderFns } from "./ModelAnno.vue?vue&type=template&id=4e191ffd&scoped=true"
import script from "./ModelAnno.vue?vue&type=script&lang=js"
export * from "./ModelAnno.vue?vue&type=script&lang=js"
import style0 from "./ModelAnno.vue?vue&type=style&index=0&id=4e191ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e191ffd",
  null
  
)

export default component.exports